/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { useIntl } from 'react-intl'
import { NumericFormat } from 'react-number-format'
import { PaymentRequestModel } from '../../models/PaymentRequestModel'
import { AsyncSelect2 } from '../../../_metronic/partials/select/AsyncSelect2'
import { STORES_ENDPOINT } from '../../constants/endpoints'
import { revertPriceNumner } from '../../selectors'

type Props = {
    show: boolean
    mode: string
    data?: PaymentRequestModel
    onClose: () => void
    onSubmit: (values: any, actions: any) => void
    onUpdateStatus: (status: string, id?: number) => void
}
const editSchema = Yup.object().shape({
    store_id: Yup.string().nullable().required('Vui lòng chọn cửa hàng'),
    amount: Yup.string().required('Vui lòng nhập giá trị')
})

const PaymentRequestEditModal: React.FC<Props> = ({ show, mode, data, onClose, onSubmit, onUpdateStatus }) => {
    const intl = useIntl();
    const [initValues, setInitValues] = useState<PaymentRequestModel>({})

    useEffect(() => {
        setInitValues({
            id: data?.id,
            store_id: data?.store_id,
            amount: data?.amount ?? 0,
            status: data?.status ?? '',
            payment_method: data?.payment_method ?? '',
            note: data?.note ?? ''
        })
    }, [data]) 
    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>Yêu cầu thanh toán #{data?.request_code ?? ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
                <Formik enableReinitialize validationSchema={editSchema} initialValues={initValues} onSubmit={onSubmit}>
                    {({ values, handleChange }) => (
                        <Form>
                            <div className="d-flex flex-column  gap-5 pt-3">
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">Cửa hàng</label>
                                    <AsyncSelect2
                                        sourceUrl={`${STORES_ENDPOINT}`}
                                        defaultOptions
                                        default
                                        name='store_id'
                                        value={{value: data?.store_id, label: data?.store?.name}}
                                        isDisabled={true}
                                    />
                                    <ErrorMessage name='store_id' className='text-danger' component='span' />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="form-label">Địa chỉ</label>
                                    <Field
                                        type='text'
                                        className='form-control'
                                        placeholder=''
                                        autoComplete='nope'
                                        disabled
                                        name='address'
                                        value={data?.store?.address ?? ''}
                                    />
                                    <div className="fv-plugins-message-container invalid-feedback">
                                        <ErrorMessage name='address' />
                                    </div>
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">Số tiền thu</label>
                                    <NumericFormat
                                        thousandSeparator=","
                                        name='amount'
                                        className='form-control'
                                        required
                                        disabled={data?.status === 'confirmed' || data?.status === 'paid' || data?.status === 'canceled'}
                                        value={values?.amount ?? 0}
                                        onBlur={(e) => {
                                            handleChange({target: {name: 'amount', value: revertPriceNumner(e.target.value)}});
                                        }}
                                    />
                                    <ErrorMessage name='value' className='text-danger' component='span' />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="form-label">Ghi chú</label>
                                    <Field
                                        as="textarea"
                                        className="form-control"
                                        value={values.note ?? ""}
                                        id="note"
                                        name="note"
                                        disabled={data?.status === 'canceled'}
                                        rows={3}
                                    />
                                    <div className="fv-plugins-message-container invalid-feedback"><ErrorMessage name='note' /></div>
                                </div>
                                <div className='fv-row flex-row-fluid fv-plugins-icon-container'>
                                    <label className='form-label' htmlFor="status">
										Trạng thái
									</label>
									<Field className="form-select cursor-pointer"
                                    as="select"
                                    name="status">
										<option disabled value="pending">Đang chờ xử lý</option>
										<option disabled value="paid">Đã thanh toán</option>
										<option disabled value="confirmed">Đã xác nhận</option>
                                        <option disabled value="canceled">Đã hủy</option>
									</Field>
                                </div>
                                {data?.payment_method && (
                                    <div className='fv-row flex-row-fluid fv-plugins-icon-container'>
                                        <label className='form-label' htmlFor="payment_method">
                                            Phương thức thanh toán
                                        </label>
                                        <Field className="form-select cursor-pointer" as="select" name="payment_method">
                                            <option disabled value="banking">Chuyển khoản</option>
                                            <option disabled value="cash">Tiền mặt</option>
                                        </Field>
                                    </div>
                                )}
                            </div>
                            <div className='d-flex mb-4 justify-content-between pt-8'>
                                <button className="btn btn-bg-secondary" type="button" onClick={() => onClose()}>Đóng</button>
                                {(data?.id && data?.status === 'pending') && (
                                    <>
                                        <button className="btn btn-bg-danger ms-auto" type="button" onClick={() => onUpdateStatus('canceled', data.id)}>Hủy yêu cầu</button>
                                    </>
                                )}
                                {(data?.id && data?.status === 'paid') && (
                                    <>
                                        <button className="btn btn-bg-success ms-2" type="button" onClick={() => onUpdateStatus('confirmed', data.id)}>Xác nhận</button>
                                    </>
                                )}
                                {(data?.status !== 'canceled') && (
                                    <>
                                        <button className="btn btn-bg-primary ms-2" type="submit">Lưu</button>
                                    </>
                                )}
                                
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default PaymentRequestEditModal
